import React, { useMemo } from "react";
import { useSelector } from 'react-redux'
import { getGlobalProps } from 'state-management/selectors'
import { useQuery } from 'react-query'
import NotAvailable from 'components/common/NotAvailable'
import Loader from 'components/general/Loader';
import Label from "components/general/Label"
import PageHeader from "components/common/PageHeader";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import MirsTable from "components/general/table/Table";
import { getCurrentBySubcode, getEvents } from "data/Querys";
import {RSC_SIZE} from "helpers/rsc"
import SportCode from "components/common/SportCode";
import Moment from 'react-moment';

function getColumn({
  id = '',
  header = '',
  code = '',
  className = 'text-start',
  eventsData = {}
}){
  return(
    {
      id: id,
      Header: <Label data={header} />,
      className: className,
      Cell: (props) => {
        let row = props.cell.row.original
        let val = row?.extensions.find(e => e.eie_code === code)?.eie_value
        let out = ''
        switch(code){
          case 'EVENT':
            out = eventsData?.events.find(e => row?.ei_value.includes(e.code))?.longDescription || row?.ei_value
            break;
          case 'STATUS':
            out = <SportCode code={val} discipline="SAL" entity="@Status"/>
            break;
          default:
            out = val
            break;
        }
      return (
          out
        )
      }
    }
  )
}

const CompetitionStatus = () => {
  const { mirs_competition, mirs_language , mirs_discipline } = useUrlFriendlyToParameters()
  const globalProps = useSelector(getGlobalProps)

  let _longDiscipline = mirs_discipline.padEnd(RSC_SIZE.FULL, '-')

  const { data:currentData, isError:currentError, isLoading:currentLoading } = useQuery(
    {
      queryKey: ['current', mirs_competition, mirs_language, _longDiscipline, 'STATUS'],
      queryFn: getCurrentBySubcode,
      refetchInterval: 10000,
      staleTime: 10000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
      //onError: (error) =>console.error(`Something went wrong: ${error.message}`),
    }
  )  

  const { data: eventsData, isError: eventsError, isLoading: eventsLoading } = useQuery(
    {
      queryKey: ['events', mirs_competition, mirs_language, mirs_discipline],
      queryFn: getEvents,
      //staleTime: Infinity,
      refetchInterval: 350000,
      staleTime: 350000,
      refetchIntervalInBackground: true,
      notifyOnChangeProps: ['data', 'error'],
    }
  ) 

  const tableColumns = useMemo(() =>
    [
      getColumn({ id: 'event', header: 'HeaderEvent', code: 'EVENT', eventsData : eventsData}),  
      getColumn({ id: 'area', header: 'HeaderArea', code: 'COURSE_AREA'}),  
      getColumn({ id: 'race', header: 'HeaderRace', code: 'UNIT_NUM', className: 'text-end'}),  
      getColumn({ id: 'windDir', header: 'HeaderWindDir', code: 'WIND_DIR', className: 'text-end'}),  
      getColumn({ id: 'windSpeed', header: 'HeaderWindSpeed', code: 'WIND_SPEED', className: 'text-end'}),  
      getColumn({ id: 'status', header: 'HeaderRaceStatus', code: 'STATUS'}),
      getColumn({ id: 'startTime', header: 'HeaderStartTime', code: 'START_TIME', className: 'text-end'}),  
      getColumn({ id: 'sailed', header: 'HeaderCourse2BSalled', code: 'COURSE_SAILED', className: 'text-center'}),  
      getColumn({ id: 'leg', header: 'HeaderCurrentLeg', code: 'LEG_CURRENT', className: 'text-center'}),  
      getColumn({ id: 'next', header: 'HeaderNextRaceEST', code: 'EST_NEXT_START', className: 'text-end'}),  
      getColumn({ id: 'limit', header: 'HeaderProtestTimeLimit', code: 'PROTEST_TIME', className: 'text-end'})
    ]
  )

  const isLoading = currentLoading || eventsLoading
  const isError = currentError || eventsError

  if (isError) { return  <NotAvailable /> }
  if (isLoading) { return <Loader /> }

  let lastUpdated = currentData?.results?.currentExtendedInfos?.find(ei => ei.ei_code === 'DATE')?.ei_value
  let tableData = currentData?.results?.currentExtendedInfos?.filter(ei => ei.ei_code === 'EVENT') || []

  return (
    <>
      <PageHeader title={<Label data="LabelCompetitionStatus" />} />
      
      <div className='mirs-page-container'>
        <MirsTable
          id={`mirs-table-competition-status`}
          caption={          
            <Moment tz={globalProps.timezone} format="dddd Do MMMM YYYY - hh:mm">
            {lastUpdated}
            </Moment>
          }
          data={tableData}
          columns={tableColumns}
          showLoading={false}
        />
      </div>
    </>
  )
}

export default CompetitionStatus